import { GameApp } from "../../../GameApp";
import { Communication, Platforms } from "neo-games";
import { DialogType, DialogTypeValue, FreeRoundBonusDialog } from "../Dialogs/FreeRoundBonusDialog";
import { ModuleManager } from "../../../Managers/ModuleManager";
import { GameManager } from "../../../Managers/GameManager";
import { FreeRoundBonusIcon } from "../Dialogs/FreeRoundBonusIcon";
import { GameData } from "../Datas/GameData";
import { DataManager } from "../../../Managers/DataManager";
import { Languages } from "../../../Utils/Languages";
import { Logger, Utils } from "neo-common";
import { ResponsibleDialog1 } from "../Dialogs/ResponsibleDialog1";
import { PlayList } from "../../../Components/Sounds/PlayList";
import { RetentionPanel } from "../../../Utils/RetentionPanel";
import { BetHigherThanMinDialog } from "../Dialogs/BetHigherThanMinDialog";

type FreeRoundsOffersResponse = Communication.Game.FreeRoundsOffersResponse;
type FreeRoundsActivateOfferResponse = Communication.Game.FreeRoundsActivateOfferResponse;
type FreeRoundsDeclineOfferResponse = Communication.Game.FreeRoundsDeclineOfferResponse;

var GameModules = Communication.Game.GameModules;
var GameStatuses = Communication.Game.GameModuleStatus;

export class FreeRoundBonus {
    public static inFrb: boolean = false;
    public static isLastFrb: boolean = false;

    public static id: number;
    public static termsUrl: string;
    public static roundsAssigned: number;
    public static roundsStarted: number;
    public static roundsPlayed: number;
    public static remainingFrbCount: number;
    public static playing: boolean = false;
    public static status: string;
    public static winType: string;
    public static validTo: string;
    public static winPayMethod: string;
    public static collectPartial: boolean;
    public static dialogType: DialogTypeValue;
    public static totalWin: number;
    public static otherOfferes: Array<Object> = [];
    public static featureName: string;

    public static wasInitialized: boolean = false;

    public static state: string = "";
    public static endMsgDisplayed: boolean = false;

    private static softInit: boolean = false;
    private static enabledUi: boolean = false;
    private static blockFrbExpiration: boolean = false;

    public static initialize(gameClient: Communication.Game.GameClient): void {
        if (!FreeRoundBonus.wasInitialized && gameClient != null) {
            gameClient
                .sendFreeRoundsOffersRequest(GameApp.key)
                .then((response: FreeRoundsOffersResponse) => {
                    FreeRoundBonus.getCurrentOfferReceived(response);
                })
                .catch((err) => {
                    FreeRoundBonus.wasInitialized = true;
                });
        }
    }

    public static activateOffer(): void {
        const offerId: number = FreeRoundBonus.id;
        if (GameApp.gameClient == null || offerId == null) {
            FreeRoundBonus.activateCurrentOffer();
            return;
        }

        //offer could be cancelled or expired on server while dialog was opened
        ModuleManager.disableBase();
        GameApp.gameClient
            .sendFreeRoundsOffersRequest(GameApp.key)
            .then((response: FreeRoundsOffersResponse) => {
                if (response != null && response.currentOffer != null && response.currentOffer.id === offerId) {
                    FreeRoundBonus.activateCurrentOffer();
                } else {
                    FreeRoundBonus.currentOfferUnavailable(response);
                }
            })
            .catch((err) => {
                FreeRoundBonus.activateCurrentOffer();
            });
    }

    private static currentOfferUnavailable(response: FreeRoundsOffersResponse): void {
        if (response == null) {
            FreeRoundBonus.expiredFreeRounds();
            return;
        }

        FreeRoundBonus.getCurrentOfferReceived(response);

        if (FreeRoundBonus.id != null) {
            //different offer is available for this game
            if (FreeRoundBonus.status === "active") {
                FreeRoundBonus.initializeFreeRounds();
            } else {
                FreeRoundBonus.showFreeRounds();
            }
        } else if (FreeRoundBonus.otherOfferes.length > 0) {
            FreeRoundBonusDialog.showDialog("other");
        } else {
            FreeRoundBonus.expiredFreeRounds();
        }
    }

    private static activateCurrentOffer(): void {
        if (FreeRoundBonus.status === "active") {
            FreeRoundBonus.inFrb = true;
            Platforms.Platforms.featureStarted({ type: "FRB" });
            FreeRoundBonusIcon.showIcon("active");
            ModuleManager.disableBase();
            if (GameApp.gameClient != null && FreeRoundBonus.id != null) {
                GameApp.gameClient.setOfferId(FreeRoundBonus.id);
            }
            GameManager.softInit();
        } else {
            ModuleManager.disableBase();
            if (GameApp.gameClient != null && FreeRoundBonus.id != null) {
                GameApp.gameClient.setOfferId(FreeRoundBonus.id);
                GameApp.gameClient
                    .sendFreeRoundsActivateOfferRequest(GameApp.key, FreeRoundBonus.id)
                    .then((response: FreeRoundsActivateOfferResponse) => {
                        FreeRoundBonus.activateOfferReceived(response);
                    });
            }
        }
    }

    public static declineOffer(): void {
        if (GameApp.gameClient != null && FreeRoundBonus.id != null) {
            FreeRoundBonusDialog.hideDialog();
            FreeRoundBonusIcon.hideAllIcons();
            GameApp.gameClient
                .sendFreeRoundsDeclineOfferRequest(GameApp.key, FreeRoundBonus.id)
                .then((response: FreeRoundsDeclineOfferResponse) => {
                    FreeRoundBonus.declineOfferReceived(response);
                    FreeRoundBonus.refreshCurrentOffers();
                });
        }
    }

    public static initializeFreeRounds(): void {
        FreeRoundBonusDialog.initialize();
        FreeRoundBonusIcon.initialize();
        if (GameApp.gameClient != null && FreeRoundBonus.id != null && FreeRoundBonus.status === "active") {
            GameApp.gameClient.setOfferId(FreeRoundBonus.id);
            FreeRoundBonusDialog.showDialog("active");
            ModuleManager.disableBase();
            FreeRoundBonusIcon.showIcon("active");
            FreeRoundBonus.inFrb = true;
            Platforms.Platforms.featureInit({ type: "FRB" });
        }
    }

    public static showFreeRounds(): void {
        if (FreeRoundBonus.id != null) {
            FreeRoundBonus.countDown();

            if (FreeRoundBonus.status !== "active") {
                if (DataManager.GameRoundClosed) {
                    FreeRoundBonusDialog.showDialog("new");
                    ModuleManager.disableBase();
                    FreeRoundBonusIcon.showIcon("new");
                } else {
                    if (!FreeRoundBonus.playing) {
                        FreeRoundBonusIcon.showIcon("new");
                        FreeRoundBonus.disableUi();
                    }
                }
            } else {
                if (!DataManager.GameRoundClosed) {
                    FreeRoundBonus.frbSpin();
                    FreeRoundBonusDialog.hideDialog();
                    FreeRoundBonus.disableUi();
                } else {
                    ModuleManager.disableBase();
                }
            }
        } else {
            FreeRoundBonus.openOther();
        }
    }

    public static reopenFreeRounds(): void {
        if (DataManager.GameRoundClosed && FreeRoundBonus.isLastFrb) {
            FreeRoundBonusIcon.showIcon("active");
            FreeRoundBonus.disableUi();
            GameApp.gameClient.setOfferId(null);
            FreeRoundBonusDialog.showDialog("end");
            FreeRoundBonus.endMsgDisplayed = true;
            ModuleManager.disableBase();
            return;
        }

        if (FreeRoundBonus.status === "new" && FreeRoundBonus.state === "new") {
            BetHigherThanMinDialog.hideDialog();
            BetHigherThanMinDialog.closeDialog();
            FreeRoundBonusDialog.showDialog("new");
            ModuleManager.disableBase();
            FreeRoundBonusIcon.showIcon("new");
            FreeRoundBonus.enableUi();
        }

        if (FreeRoundBonus.state === "active") {
            FreeRoundBonusDialog.showDialog("active");
            ModuleManager.disableBase();
            FreeRoundBonusIcon.showIcon("active");
            FreeRoundBonus.enableUi();
        }

        if (FreeRoundBonus.state === "end") {
            FreeRoundBonusIcon.showIcon("active");
            FreeRoundBonus.disableUi();
            GameApp.gameClient.setOfferId(null);
            FreeRoundBonusDialog.showDialog("end");
            FreeRoundBonus.endMsgDisplayed = true;
            ModuleManager.disableBase();
        }

        if (FreeRoundBonus.state === "other") {
            if (FreeRoundBonus.validTo != null) {
                let countDownDate: number = new Date(FreeRoundBonus.validTo + "+00:00").getTime();
                let now: number = new Date().getTime();
                let distance: number = countDownDate - now;

                if (distance > 0) {
                    FreeRoundBonusDialog.showDialog("other");
                    ModuleManager.disableBase();
                    FreeRoundBonusIcon.showIcon("new");
                    FreeRoundBonus.enableUi();
                }
            } else if (FreeRoundBonusDialog.revalidateOtherGames()) {
                FreeRoundBonusDialog.showDialog("other");
                ModuleManager.disableBase();
                FreeRoundBonusIcon.showIcon("new");
                FreeRoundBonus.enableUi();
            }
        }

        if (FreeRoundBonus.state === "") {
            FreeRoundBonus.enableUi();
        }
    }

    public static openOther(): void {
        if (FreeRoundBonus.id == null && FreeRoundBonusDialog.revalidateOtherGames()) {
            FreeRoundBonus.countDownOther();
            if (DataManager.GameRoundClosed) {
                FreeRoundBonusIcon.showIcon("new");
                FreeRoundBonus.enableUi();
            } else {
                FreeRoundBonusIcon.showIcon("new");
                FreeRoundBonus.disableUi();
            }
        }
    }

    public static endFreeRounds(): void {
        if (FreeRoundBonus.id != null) {
            DataManager.Collectable = true;
            FreeRoundBonus.disableUi();
            if (GameManager.gameResponse["freeRounds"] != null) {
                if (GameManager.gameResponse["freeRounds"]["totalWin"] != null) {
                    FreeRoundBonus.totalWin = GameManager.gameResponse["freeRounds"]["totalWin"];
                }
                if (GameManager.gameResponse["freeRounds"]["status"] != null) {
                    if (GameManager.gameResponse["freeRounds"]["status"] === "pending") {
                        FreeRoundBonus.status = GameManager.gameResponse["freeRounds"]["status"];
                    }
                }
            }
            GameApp.gameClient.setOfferId(null);
            FreeRoundBonusDialog.showDialog("end");
            FreeRoundBonus.endMsgDisplayed = true;
        }
    }

    public static finishFreeRounds(): void {
        FreeRoundBonusIcon.hideAllIcons();
        FreeRoundBonus.id = null;
        FreeRoundBonus.inFrb = false;
        Platforms.Platforms.featureFinished({ type: "FRB" });
        FreeRoundBonus.isLastFrb = false;
        FreeRoundBonus.endMsgDisplayed = false;
        FreeRoundBonus.wasInitialized = false;
        FreeRoundBonus.softInit = false;
        FreeRoundBonus.remainingFrbCount = null;
        FreeRoundBonus.roundsAssigned = 0;
        FreeRoundBonus.roundsPlayed = 0;
        FreeRoundBonus.roundsStarted = 0;
        FreeRoundBonus.dialogType = DialogType.Other as DialogTypeValue;
        FreeRoundBonus.featureName = null;
        FreeRoundBonus.status = null;

        if (FreeRoundBonus.winPayMethod === "cumulative") {
            if (FreeRoundBonus.totalWin != null && FreeRoundBonus.totalWin > 0) {
                PlayList.play("SND_BaseCollect");
                ModuleManager.disableBase();
                ModuleManager.resetSceneAsOnCollect(GameModules.Base);
            }
        }

        FreeRoundBonus.refreshCurrentOffers();
    }

    public static refreshCurrentOffers(resetScreen: boolean = false): void {
        if (GameApp.gameClient != null) {
            GameApp.gameClient
                .sendFreeRoundsOffersRequest(GameApp.key)
                .then((response: FreeRoundsOffersResponse) => {
                    FreeRoundBonus.getCurrentOfferReceived(response, resetScreen);

                    if (FreeRoundBonus.id != null) {
                        FreeRoundBonus.softInit = true;
                        if (FreeRoundBonus.status === "active") {
                            FreeRoundBonus.initializeFreeRounds();
                        } else {
                            FreeRoundBonus.showFreeRounds();
                        }
                    } else {
                        GameManager.softInit(resetScreen);
                        FreeRoundBonus.disableUi();
                        if (DataManager.GameRoundClosed) {
                            GameManager.canExit();
                        }
                    }
                    return null;
                })
                .catch((err) => {
                    FreeRoundBonus.wasInitialized = true;

                    GameManager.softInit(resetScreen);
                    FreeRoundBonus.disableUi();
                    if (DataManager.GameRoundClosed) {
                        GameManager.canExit();
                    }
                });
        }
    }

    public static expiredFreeRounds(showDialog: boolean = true): void {
        FreeRoundBonusIcon.hideAllIcons();
        FreeRoundBonus.id = null;
        FreeRoundBonus.inFrb = false;
        Platforms.Platforms.featureFinished({ type: "FRB" });
        FreeRoundBonus.isLastFrb = false;
        FreeRoundBonus.endMsgDisplayed = false;
        FreeRoundBonus.softInit = false;
        FreeRoundBonus.remainingFrbCount = null;
        FreeRoundBonus.roundsAssigned = 0;
        FreeRoundBonus.roundsPlayed = 0;
        FreeRoundBonus.roundsStarted = 0;
        FreeRoundBonus.dialogType = DialogType.Other as DialogTypeValue;
        FreeRoundBonus.featureName = null;
        GameApp.gameClient.setOfferId(null);
        if (showDialog) FreeRoundBonusDialog.showDialog("expired");
    }

    public static getCurrentOfferReceived(response: FreeRoundsOffersResponse, resetScreen: boolean = false): void {
        FreeRoundBonus.totalWin = 0;
        FreeRoundBonus.termsUrl = null;

        if (response != null) {
            FreeRoundBonus.wasInitialized = true;
            if (response.currentOffer != null) {
                if (response.currentOffer.id != null) FreeRoundBonus.id = response.currentOffer.id;
                if (response.currentOffer.termsUrl != null) FreeRoundBonus.termsUrl = response.currentOffer.termsUrl;
                if (response.currentOffer.roundsAssigned != null)
                    FreeRoundBonus.roundsAssigned = response.currentOffer.roundsAssigned;
                if (response.currentOffer.roundsStarted != null)
                    FreeRoundBonus.roundsStarted = response.currentOffer.roundsStarted;
                if (response.currentOffer.roundsPlayed != null)
                    FreeRoundBonus.roundsPlayed = response.currentOffer.roundsPlayed;
                if (response.currentOffer.remainingCount != null)
                    FreeRoundBonus.remainingFrbCount = response.currentOffer.remainingCount;
                if (response.currentOffer.playing != null) FreeRoundBonus.playing = response.currentOffer.playing;
                if (response.currentOffer.status != null) FreeRoundBonus.status = response.currentOffer.status;
                if (response.currentOffer.winType != null) FreeRoundBonus.winType = response.currentOffer.winType;
                if (response.currentOffer.validTo != null) FreeRoundBonus.validTo = response.currentOffer.validTo;
                if (response.currentOffer.winPayMethod != null)
                    FreeRoundBonus.winPayMethod = response.currentOffer.winPayMethod;
                if (response.currentOffer.collectPartial != null)
                    FreeRoundBonus.collectPartial = response.currentOffer.collectPartial;
                if (response.currentOffer.hasBuyFeature != null) {
                    FreeRoundBonus.dialogType = (
                        response.currentOffer.hasBuyFeature ? DialogType.FFR : DialogType.FRB
                    ) as DialogTypeValue;
                } else {
                    FreeRoundBonus.dialogType = DialogType.Other as DialogTypeValue;
                }
                if (response.currentOffer.buyFeatureName != null)
                    FreeRoundBonus.featureName = response.currentOffer.buyFeatureName;

                if (FreeRoundBonus.remainingFrbCount == null) {
                    if (FreeRoundBonus.roundsAssigned != null && FreeRoundBonus.roundsStarted != null) {
                        FreeRoundBonus.remainingFrbCount = FreeRoundBonus.roundsAssigned - FreeRoundBonus.roundsStarted;
                    }
                }

                if (FreeRoundBonus.remainingFrbCount != null && FreeRoundBonus.remainingFrbCount === 0) {
                    FreeRoundBonus.isLastFrb = true;
                }
            } else {
                FreeRoundBonus.id = null;
                FreeRoundBonus.isLastFrb = false;
                FreeRoundBonus.remainingFrbCount = null;
                FreeRoundBonus.roundsAssigned = 0;
                FreeRoundBonus.roundsPlayed = 0;
                FreeRoundBonus.roundsStarted = 0;
                FreeRoundBonus.dialogType = DialogType.Other as DialogTypeValue;
                FreeRoundBonus.featureName = null;
            }
            FreeRoundBonus.otherOfferes = [];
            if (response.otherOffers != null) {
                FreeRoundBonus.otherOfferes = response.otherOffers;
            }
        } else if (resetScreen) {
            FreeRoundBonus.expiredFreeRounds(false);
            GameManager.softInit(resetScreen);
        }
    }

    private static activateOfferReceived(response: FreeRoundsActivateOfferResponse): void {
        FreeRoundBonus.inFrb = true;
        Platforms.Platforms.featureStarted({ type: "FRB" });
        FreeRoundBonus.status = "active";
        GameManager.softInit();
        FreeRoundBonusIcon.showIcon("active");
    }

    private static declineOfferReceived(response: FreeRoundsDeclineOfferResponse): void {
        FreeRoundBonus.id = null;
        FreeRoundBonus.softInit = false;
        FreeRoundBonus.remainingFrbCount = null;
        FreeRoundBonus.roundsAssigned = 0;
        FreeRoundBonus.roundsPlayed = 0;
        FreeRoundBonus.roundsStarted = 0;
        FreeRoundBonus.dialogType = DialogType.Other as DialogTypeValue;
        FreeRoundBonus.featureName = null;
    }

    public static valid(): string {
        let str: string = "";
        if (FreeRoundBonus.validTo != null) {
            str = FreeRoundBonus.validTo;
        }
        return str;
    }

    public static assignedCount(): string {
        let str: string = "0";
        if (FreeRoundBonus.roundsAssigned != null) {
            str = FreeRoundBonus.roundsAssigned.toString();
        }
        return str;
    }

    public static remainingCount(): string {
        let str: string = "0";

        if (FreeRoundBonus.remainingFrbCount == null) {
            if (FreeRoundBonus.roundsAssigned != null && FreeRoundBonus.roundsStarted != null) {
                FreeRoundBonus.remainingFrbCount = FreeRoundBonus.roundsAssigned - FreeRoundBonus.roundsStarted;
            }
        }

        if (FreeRoundBonus.remainingFrbCount != null) {
            //if dynamic frb was updated in last frb, dont update frb remaining count in icon
            if (FreeRoundBonus.id === -1 && FreeRoundBonus.isLastFrb) {
                str = "0";
            } else {
                str = FreeRoundBonus.remainingFrbCount.toString();
            }
        }

        return str;
    }

    public static rulesLink(): string {
        let str: string = "";
        if (FreeRoundBonus.termsUrl != null) {
            str = '<a href="' + FreeRoundBonus.termsUrl + '" target="_blank">' + FreeRoundBonus.termsUrl + "</a>";
        }
        return str;
    }

    public static win(): string {
        let str: string = "";
        if (FreeRoundBonus.totalWin != null && FreeRoundBonus.totalWin > 0) {
            str =
                Languages.formatText(Languages.FormatMoney, FreeRoundBonus.totalWin.toString()) +
                " " +
                DataManager.getDataById(GameData.DataCurrency);
        }
        return str;
    }

    public static frbSpin(): void {
        if (FreeRoundBonus.id == null && !FreeRoundBonus.inFrb) {
            return;
        }
        FreeRoundBonus.blockFrbExpiration = true;
        if (FreeRoundBonus.inFrb) {
            DataManager.AutoplayLossLimit = "∞";
        }
        if (GameManager.gameResponse["freeRounds"] != null) {
            if (GameManager.gameResponse["freeRounds"]["roundsStarted"] != null) {
                FreeRoundBonus.roundsStarted = GameManager.gameResponse["freeRounds"]["roundsStarted"];
            }
            if (GameManager.gameResponse["freeRounds"]["totalWin"] != null) {
                FreeRoundBonus.totalWin = GameManager.gameResponse["freeRounds"]["totalWin"];
            }

            if (GameManager.gameResponse["freeRounds"]["totalWin"] != null) {
                FreeRoundBonus.remainingFrbCount = GameManager.gameResponse["freeRounds"]["remainingCount"];
            } else {
                if (FreeRoundBonus.roundsAssigned != null && FreeRoundBonus.roundsStarted != null) {
                    FreeRoundBonus.remainingFrbCount = FreeRoundBonus.roundsAssigned - FreeRoundBonus.roundsStarted;
                }
            }
        }
        DataManager.updateGameDataFromModule(GameData.DataFrbRemainginCount, FreeRoundBonus.remainingCount());
        DataManager.updateDataElement(GameData.DataFrbRemainginCount, FreeRoundBonus.remainingCount());
        if (FreeRoundBonus.remainingFrbCount != null && FreeRoundBonus.remainingFrbCount === 0) {
            FreeRoundBonus.isLastFrb = true;
            DataManager.Autoplay = false;
            DataManager.AutoplayCount = "∞";
            DataManager.AutoplayLossLimit = "∞";
            DataManager.AutoplayWinLimit = "∞";
        }
    }

    private static countDown(): void {
        if (FreeRoundBonus.validTo != null) {
            let countDownDate: number = new Date(FreeRoundBonus.validTo + "+00:00").getTime();
            let now: number = new Date().getTime();
            let distance: number = countDownDate - now;
            let days: number = Math.floor(distance / (1000 * 60 * 60 * 24));
            let hours: number = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes: number = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            let seconds: number = Math.floor((distance % (1000 * 60)) / 1000);

            if (!FreeRoundBonus.blockFrbExpiration && distance < 0) {
                FreeRoundBonus.id = null;
                FreeRoundBonus.softInit = false;
                FreeRoundBonus.remainingFrbCount = null;
                FreeRoundBonus.roundsAssigned = 0;
                FreeRoundBonus.roundsPlayed = 0;
                FreeRoundBonus.roundsStarted = 0;
                FreeRoundBonus.dialogType = DialogType.Other as DialogTypeValue;

                if (FreeRoundBonus.state !== "end" && FreeRoundBonus.state !== "other") {
                    if (!FreeRoundBonusDialog.revalidateOtherGames()) {
                        FreeRoundBonusDialog.hideDialog();
                        FreeRoundBonusIcon.hideAllIcons();
                        FreeRoundBonus.state = "expired";
                        FreeRoundBonus.enableGame();
                    } else {
                        FreeRoundBonusDialog.hideDialog();
                        FreeRoundBonus.enableGame();
                    }
                }
            } else {
                if (days > 0) {
                    DataManager.updateGameDataFromModule(GameData.DataFrbExpiryTime, days + "d");
                    DataManager.updateDataElement(GameData.DataFrbExpiryTime, days + "d");
                } else if (hours > 0) {
                    DataManager.updateGameDataFromModule(GameData.DataFrbExpiryTime, hours + ":" + minutes + "h");
                    DataManager.updateDataElement(GameData.DataFrbExpiryTime, hours + ":" + minutes + "h");
                } else if (minutes > 0) {
                    DataManager.updateGameDataFromModule(GameData.DataFrbExpiryTime, minutes + ":" + seconds + "s");
                    DataManager.updateDataElement(GameData.DataFrbExpiryTime, minutes + ":" + seconds + "s");
                }

                setTimeout(() => {
                    FreeRoundBonus.countDown();
                }, 1000);
            }
        }
    }

    private static countDownOther(): void {
        if (!FreeRoundBonusDialog.revalidateOtherGames()) {
            FreeRoundBonusDialog.hideDialog();
            FreeRoundBonusIcon.hideAllIcons();
            FreeRoundBonus.enableGame();
        } else {
            setTimeout(() => {
                FreeRoundBonus.countDownOther();
            }, 2000);
        }
    }

    public static hasNewActiveOffer(): boolean {
        FreeRoundBonus.trySetDynamicFrbCount();
        //frb id -1 is dynamic frb
        if (FreeRoundBonus.id == null && FreeRoundBonus.remainingFrbCount > 0) {
            return true;
        }

        return false;
    }

    public static hasPendingDynamicFrb(): boolean {
        if (FreeRoundBonus.inFrb || FreeRoundBonus.id != null) {
            return false;
        }
        const freeRounds = GameManager.gameResponse["freeRounds"];
        const remainingCount: number = freeRounds != null ? freeRounds["remainingCount"] : null;
        return remainingCount > 0;
    }

    public static updateRemainingCount(count: number): void {
        //if not initialized yet
        if (FreeRoundBonus.id == null || (FreeRoundBonus.id > -1 && FreeRoundBonus.status != "active")) {
            //check if we can show dialog
            if (count > 0) {
                if (FreeRoundBonus.canInitDynamicFRB()) {
                    FreeRoundBonus.softInitialize();
                } else {
                    //stop autoplay if in base module, to let game check for new frb
                    if (GameManager.baseResponse != null && GameManager.baseResponse.status === GameStatuses.Enabled) {
                        DataManager.Autoplay = false;
                    }
                    FreeRoundBonus.remainingFrbCount = count;
                }
            }
        } else if (FreeRoundBonus.id === -1) {
            if (count > 0) {
                if (FreeRoundBonus.remainingFrbCount > 0) {
                    FreeRoundBonus.isLastFrb = false;
                    FreeRoundBonus.remainingFrbCount = count;
                    DataManager.updateGameDataFromModule(GameData.DataFrbRemainginCount, count.toString());
                    DataManager.updateDataElement(GameData.DataFrbRemainginCount, count.toString());
                } else {
                    //updated frb in last frb spin will be show as new frb after end dialog
                    FreeRoundBonus.remainingFrbCount = count;
                }
            } else if (count === 0) {
                //currently in frb
                if (FreeRoundBonus.remainingFrbCount > 0) {
                    FreeRoundBonus.remainingFrbCount = count;
                    DataManager.updateGameDataFromModule(GameData.DataFrbRemainginCount, count.toString());
                    DataManager.updateDataElement(GameData.DataFrbRemainginCount, count.toString());

                    FreeRoundBonus.isLastFrb = true;
                    if (DataManager.GameRoundClosed && !DataManager.Autoplay && FreeRoundBonus.enabledUi) {
                        FreeRoundBonus.endFreeRounds();
                    } else {
                        DataManager.Autoplay = false;
                    }
                }
            }
        }
    }

    private static canInitDynamicFRB(): boolean {
        return (
            !FreeRoundBonusIcon.isDisabled() &&
            DataManager.GameRoundClosed &&
            !DataManager.Autoplay &&
            !ResponsibleDialog1.opened
        );
    }

    public static softInitialize(): void {
        if (!FreeRoundBonus.softInit) {
            FreeRoundBonus.softInit = true;
            DataManager.Autoplay = false;
            ModuleManager.disableBase();
            GameManager.gameClient
                .sendFreeRoundsOffersRequest(GameApp.key)
                .then((response: FreeRoundsOffersResponse) => {
                    FreeRoundBonus.getCurrentOfferReceived(response);
                    FreeRoundBonus.initializeFreeRounds();
                })
                .catch((err) => {
                    FreeRoundBonus.softInit = false;
                    FreeRoundBonus.wasInitialized = true;
                    ModuleManager.restoreGameRound(GameModules.Base);
                });
        }
    }

    public static disableUi(): void {
        FreeRoundBonus.enabledUi = false;
        FreeRoundBonusDialog.hideDialog();
        FreeRoundBonusIcon.disableActiveIcon();
    }

    public static trySetDynamicFrbCount(): void {
        const freeRounds = GameManager.gameResponse["freeRounds"];
        const remainingCount: number = freeRounds != null ? freeRounds["remainingCount"] : null;

        if ((FreeRoundBonus.id != null || FreeRoundBonus.inFrb) && remainingCount !== 0) {
            return;
        }
        if (!ModuleManager.canShowDynamicOffer()) {
            return;
        }
        if (remainingCount > 0) {
            FreeRoundBonus.remainingFrbCount = remainingCount;
        }
    }

    public static enableUi(): void {
        if (!ResponsibleDialog1.opened) {
            FreeRoundBonus.enabledUi = true;

            if (FreeRoundBonus.hasNewActiveOffer()) {
                FreeRoundBonus.softInitialize();
                return;
            }

            //stop enabling icon in cumulative frb (should act like in FS so icon is not clickable)
            if (FreeRoundBonus.inFrb && FreeRoundBonus.winPayMethod == "cumulative") {
                return;
            }

            FreeRoundBonusIcon.enableActiveIcon();
        }
    }

    public static enableGame(): void {
        if (FreeRoundBonus.softInit) {
            GameManager.softInit();
            FreeRoundBonus.softInit = false;
        } else if (
            ModuleManager.getActiveGameModules().length == 0 ||
            ModuleManager.getActiveGameModules().indexOf(GameModules.Base) != -1
        ) {
            ModuleManager.restoreGameRound(GameModules.Base);
        }
        RetentionPanel.revalidate();
    }

    public static enableFrbExpiration(): void {
        FreeRoundBonus.blockFrbExpiration = false;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Bonuses/FreeRoundBonus.ts
 **/